import { useEffect, useState } from 'react'

/**
 * Yeni sürüm algılama — YES-90.
 *
 * Derlemeye gömülen sürüm ile sunucudaki `version.json` karşılaştırılır.
 * Farklıysa yeni bir deploy olmuş demektir: kullanıcının açık sekmesi eski
 * JavaScript'i çalıştırıyor ve API sözleşmesi değişmiş olabilir.
 *
 * Otomatik yenilemiyoruz — kullanıcı form doldurmuş olabilir. Bant gösterip
 * kararı ona bırakıyoruz.
 */
const KONTROL_ARALIGI_MS = 5 * 60 * 1000

export function useYeniSurum(): boolean {
  const [yeniSurumVar, setYeniSurumVar] = useState(false)

  useEffect(() => {
    if (__APP_VERSION__ === 'dev') return

    let iptal = false

    async function kontrolEt() {
      try {
        // `cache: 'no-store'`: nginx zaten no-store diyor ama araya bir vekil
        // girerse bu güvenceyi kaybetmeyelim.
        const response = await fetch('/version.json', { cache: 'no-store' })
        if (!response.ok) return
        const { version } = (await response.json()) as { version: string }
        if (!iptal && version && version !== __APP_VERSION__) setYeniSurumVar(true)
      } catch {
        // Ağ hatası: bir sonraki kontrolde tekrar denenir.
      }
    }

    void kontrolEt()
    const zamanlayici = setInterval(kontrolEt, KONTROL_ARALIGI_MS)
    // Sekmeye geri dönüldüğünde de bak: kullanıcı sekmeyi günlerce açık
    // bırakabiliyor ve dönüşü, aralığı beklemekten daha iyi bir işaret.
    document.addEventListener('visibilitychange', kontrolEt)

    return () => {
      iptal = true
      clearInterval(zamanlayici)
      document.removeEventListener('visibilitychange', kontrolEt)
    }
  }, [])

  return yeniSurumVar
}
